/**
 * Simple payback period (in years): investment ÷ annual € savings.
 * Returns null whenever it can't be computed meaningfully — investment unknown
 * (some equipment has no catalog price, e.g. a manually-entered flow rate) or
 * savings are zero/unavailable (no water price configured, or no gain).
 */
export const computePaybackYears = ({ investmentEur, investmentFullyKnown, savingsEurPerYear }) => {
  if (!investmentFullyKnown || investmentEur == null || savingsEurPerYear == null || savingsEurPerYear <= 0) {
    return null;
  }
  return investmentEur / savingsEurPerYear;
};

// Below one year, months read more concretely than a "0,3 an" fraction.
export const formatPaybackYears = (years) => {
  if (years == null) return 'N/A';
  if (years < 1) return `${Math.round(years * 12)} mois`;
  return `${years.toFixed(1)} ans`;
};
